<template>
  <v-dialog v-model="mostrarDialogoConfirmacaoReenvio" persistent max-width="800">
    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        Motivo da Solicitação de Documento
      </v-card-title>
      <v-card-text class="pb-0 az-form-content">
        <div class="username-display">
          <label style="color: gray"><strong>Participante</strong></label>
          <p class="text--secondary"> {{fornecedor.razaoSocial}} </p>
        </div>
        <v-layout class="d-flex">
          <v-flex xs12>
            <v-text-field
              v-model="nomeDocumentoInformado"
              label="Nome do documento"
              placeholder="Digite aqui o nome do documento"
              outlined
              counter="100"
              maxlength="100"
              :rules="[v => v && v.trim() ? true : 'Nome do documento é obrigatório']"
              ref="nomeDocumento"
              class="required-field"
            />
          </v-flex>
        </v-layout>
        <v-textarea
          v-model="motivoSolicitacaoEnvioDocumento"
          label="Motivo Solicitação"
          placeholder="Digite aqui o motivo"
          outlined
          counter="1000"
          maxlength="1000"
          :rules="[v => v && v.trim() ? true : 'Motivo da solicitação é obrigatório']"
          ref="motivoSolicitacao"
          class="required-field"
        />
      </v-card-text>
      <v-card-actions class="acoes justify-space-between">
        <v-btn class="ml-3" color="#777" flat @click="fecharDialogoSolicitacaoEnvio">
          Cancelar
        </v-btn>
        <v-btn
          class="botao-primario confirmar mr-3" @click="confirmarSolicitacao">
          Solicitar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from "vuex";
import {mutationTypes} from "@/commons/constants";

export default {
  name: 'AcoesSolicitarEnvioDocumento',
  props: {
    fornecedor: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      nomeDocumentoInformado: "",
      motivoSolicitacaoEnvioDocumento: "",
      nomeFornecedor: "Lucas Avanzi",
      mostrarDialogoConfirmacaoReenvio: false
    }
  },
  computed: {
    ...mapState(['mostrarModalSolicitacaoEnvioDocumentoCredenciamento']),
    // isEdicao() {
    //   return !!this.$route.query.edicao
    // },
  },
  methods: {
    fecharDialogoSolicitacaoEnvio() {
      this.mostrarDialogoConfirmacaoReenvio = false
      this.resetarCamposERegras()
    },
    resetarCamposERegras() {
      this.nomeDocumentoInformado = '';
      this.motivoSolicitacaoEnvioDocumento = '';
      this.$nextTick(() => {
        if (this.$refs.nomeDocumento && this.$refs.nomeDocumento.reset) {
          this.$refs.nomeDocumento.reset();
        }
        if (this.$refs.motivoSolicitacao && this.$refs.motivoSolicitacao.reset) {
          this.$refs.motivoSolicitacao.reset();
        }
      });
    },
    async confirmarSolicitacao() {
      const informacoesValidas = await this.validarCampos();

      if(informacoesValidas) {
        const informacoesSolicitacao = {
          descricao: this.nomeDocumentoInformado,
          motivo: this.motivoSolicitacaoEnvioDocumento
        }

        this.$emit('emitirSolicitacaoEnvioNovoDocumento', informacoesSolicitacao);
        this.fecharDialogoSolicitacaoEnvio()
      }

    },
    async validarCampos(){
      const nomeDocumentoValido = await this.$refs.nomeDocumento.validate();
      const motivoSolicitacaoValido = await this.$refs.motivoSolicitacao.validate();

      return nomeDocumentoValido && motivoSolicitacaoValido
    }
  },
  watch: {
    mostrarModalSolicitacaoEnvioDocumentoCredenciamento(novoValor) {
      this.mostrarDialogoConfirmacaoReenvio = novoValor
    },
    mostrarDialogoConfirmacaoReenvio(novoValor) {
      this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_MOSTRAR_MODAL_SOLICITACAO_ENVIO_DOCUMENTO, novoValor)
    }
  }
}
</script>

<style scoped lang="stylus">
.modal-title
  justify-content space-between

  .v-btn
    padding 0
    margin 0
    color #fff
    box-sizing border-box
    min-width 25px

.botao-primario
  padding 0 25px
  border 1px solid #0067a5
  background-color #0067a5 !important
  color #fff !important
  box-sizing border-box
  margin-left 15px !important

.acoes
  padding 20px 0 !important

</style>